import * as yup from "yup";

export const validationSchema = yup.object({
  label: yup.string().required('Label is required').min(3).max(50),
  appLabel: yup.string().required('App Label is required').min(3).max(50),
})
